{
  "three-acts": {
    "name": "Tre atti",
    "summary": "Impostazione, confronto e risoluzione: la forma condivisa dalla maggior parte dei romanzi e dei film.",
    "bestFor": "Qualsiasi genere e una prima stesura da mantenere semplice.",
    "metaTitle": "Modello narrativo in tre atti — Musael",
    "metaDescription": "Impostazione, confronto e risoluzione: la forma di molti romanzi e film. Per qualsiasi genere e una prima stesura semplice.",
    "acts": [
      {
        "title": "Atto I: Impostazione",
        "synopsis": "Chi è il protagonista, cosa vuole e l'evento che mette fine alla sua vita normale.",
        "chapters": [
          {
            "title": "Il mondo ordinario",
            "synopsis": "Il protagonista nel suo ambiente, con il desiderio e il difetto che la storia metterà alla prova.",
            "scenes": [
              {
                "title": "Immagine iniziale",
                "synopsis": "Un'istantanea del protagonista prima che qualcosa cambi."
              },
              {
                "title": "L'aggancio",
                "synopsis": "Qualcosa di piccolo ma strano che promette guai."
              }
            ]
          },
          {
            "title": "L'incidente scatenante",
            "synopsis": "L'evento che il protagonista non può ignorare.",
            "scenes": [
              {
                "title": "Incidente scatenante",
                "synopsis": "Il problema arriva e non se ne va."
              },
              {
                "title": "Esitazione",
                "synopsis": "Il protagonista esita e vediamo cosa rischia di perdere."
              }
            ]
          },
          {
            "title": "Il varco della soglia",
            "synopsis": "Il protagonista si impegna; tornare indietro non è più facile.",
            "scenes": [
              {
                "title": "La decisione",
                "synopsis": "Il protagonista sceglie di agire e lascia ciò che conosce."
              }
            ]
          }
        ]
      },
      {
        "title": "Atto II: Confronto",
        "synopsis": "Il protagonista prova, fallisce e impara, mentre la posta in gioco continua a salire.",
        "chapters": [
          {
            "title": "La posta in gioco sale",
            "synopsis": "Nuove regole, alleati e nemici; le prime vittorie hanno un prezzo.",
            "scenes": [
              {
                "title": "Prima prova",
                "synopsis": "Il protagonista incontra il nuovo mondo e in parte lo fraintende."
              },
              {
                "title": "Alleati e nemici",
                "synopsis": "Chi aiuta, chi ostacola e perché."
              }
            ]
          },
          {
            "title": "Il punto centrale",
            "synopsis": "Un ribaltamento che cambia il senso della storia.",
            "scenes": [
              {
                "title": "Punto centrale",
                "synopsis": "Una falsa vittoria o una falsa sconfitta; il protagonista smette di reagire e prende l'iniziativa."
              }
            ]
          },
          {
            "title": "Tutto va in pezzi",
            "synopsis": "L'opposizione si stringe e il difetto costa caro al protagonista.",
            "scenes": [
              {
                "title": "La stretta",
                "synopsis": "Ogni piano incontra resistenza; i rapporti si incrinano."
              },
              {
                "title": "Tutto è perduto",
                "synopsis": "Il punto più basso: l'obiettivo sembra irraggiungibile per sempre."
              }
            ]
          }
        ]
      },
      {
        "title": "Atto III: Risoluzione",
        "synopsis": "Il protagonista cambia, affronta la prova finale e inizia una nuova normalità.",
        "chapters": [
          {
            "title": "Il culmine",
            "synopsis": "Il confronto finale, vinto grazie alla lezione del secondo atto.",
            "scenes": [
              {
                "title": "Il piano finale",
                "synopsis": "Il protagonista riunisce ciò che ha imparato e fa un ultimo tentativo."
              },
              {
                "title": "Culmine",
                "synopsis": "Il confronto decisivo."
              }
            ]
          },
          {
            "title": "La nuova normalità",
            "synopsis": "Cosa è cambiato, per il protagonista e per il mondo.",
            "scenes": [
              {
                "title": "Immagine conclusiva",
                "synopsis": "Uno specchio dell'immagine iniziale, che mostra la strada percorsa dal protagonista."
              }
            ]
          }
        ]
      }
    ]
  },
  "heros-journey": {
    "name": "Il viaggio dell'eroe",
    "summary": "Dodici tappe dalla chiamata all'avventura al ritorno a casa, divise in partenza, iniziazione e ritorno.",
    "bestFor": "Fantasy, avventura e missioni.",
    "metaTitle": "Modello del viaggio dell'eroe — Musael",
    "metaDescription": "Dodici tappe dalla chiamata all'avventura al ritorno a casa, in partenza, iniziazione e ritorno. Per fantasy, avventure e missioni.",
    "acts": [
      {
        "title": "Partenza",
        "synopsis": "Il protagonista lascia il mondo conosciuto.",
        "chapters": [
          {
            "title": "Il mondo ordinario",
            "synopsis": "Il protagonista prima dell'avventura: casa, abitudini e ciò che manca.",
            "scenes": [
              {
                "title": "Il mondo ordinario",
                "synopsis": "Il protagonista prima dell'avventura: casa, abitudini e ciò che manca."
              }
            ]
          },
          {
            "title": "La chiamata all'avventura",
            "synopsis": "Una sfida o un messaggio turba il mondo ordinario.",
            "scenes": [
              {
                "title": "La chiamata all'avventura",
                "synopsis": "Una sfida o un messaggio turba il mondo ordinario."
              }
            ]
          },
          {
            "title": "Rifiuto della chiamata",
            "synopsis": "La paura o il dovere trattengono il protagonista.",
            "scenes": [
              {
                "title": "Rifiuto della chiamata",
                "synopsis": "La paura o il dovere trattengono il protagonista."
              }
            ]
          },
          {
            "title": "Incontro con il mentore",
            "synopsis": "Qualcuno offre consigli, addestramento o un dono.",
            "scenes": [
              {
                "title": "Incontro con il mentore",
                "synopsis": "Qualcuno offre consigli, addestramento o un dono."
              }
            ]
          },
          {
            "title": "Il varco della prima soglia",
            "synopsis": "Il protagonista entra nel mondo straordinario.",
            "scenes": [
              {
                "title": "Il varco della prima soglia",
                "synopsis": "Il protagonista entra nel mondo straordinario."
              }
            ]
          }
        ]
      },
      {
        "title": "Iniziazione",
        "synopsis": "Le prove nel mondo straordinario e la grande sfida.",
        "chapters": [
          {
            "title": "Prove, alleati e nemici",
            "synopsis": "Il protagonista impara le regole del nuovo mondo.",
            "scenes": [
              {
                "title": "Prove, alleati e nemici",
                "synopsis": "Il protagonista impara le regole del nuovo mondo."
              }
            ]
          },
          {
            "title": "Avvicinamento alla caverna più profonda",
            "synopsis": "I preparativi per il pericolo centrale.",
            "scenes": [
              {
                "title": "Avvicinamento alla caverna più profonda",
                "synopsis": "I preparativi per il pericolo centrale."
              }
            ]
          },
          {
            "title": "La prova suprema",
            "synopsis": "Una crisi di vita o di morte; qualcosa nel protagonista muore.",
            "scenes": [
              {
                "title": "La prova suprema",
                "synopsis": "Una crisi di vita o di morte; qualcosa nel protagonista muore."
              }
            ]
          },
          {
            "title": "La ricompensa",
            "synopsis": "Il protagonista conquista il tesoro, la conoscenza o la riconciliazione.",
            "scenes": [
              {
                "title": "La ricompensa",
                "synopsis": "Il protagonista conquista il tesoro, la conoscenza o la riconciliazione."
              }
            ]
          }
        ]
      },
      {
        "title": "Ritorno",
        "synopsis": "La strada verso casa, un'ultima prova e ciò che il protagonista porta con sé.",
        "chapters": [
          {
            "title": "La via del ritorno",
            "synopsis": "Il protagonista si dirige verso casa, spesso inseguito.",
            "scenes": [
              {
                "title": "La via del ritorno",
                "synopsis": "Il protagonista si dirige verso casa, spesso inseguito."
              }
            ]
          },
          {
            "title": "Resurrezione",
            "synopsis": "Una prova finale in cui viene usato tutto ciò che ha imparato.",
            "scenes": [
              {
                "title": "Resurrezione",
                "synopsis": "Una prova finale in cui viene usato tutto ciò che ha imparato."
              }
            ]
          },
          {
            "title": "Ritorno con l'elisir",
            "synopsis": "Il protagonista torna a casa cambiato, con qualcosa da condividere.",
            "scenes": [
              {
                "title": "Ritorno con l'elisir",
                "synopsis": "Il protagonista torna a casa cambiato, con qualcosa da condividere."
              }
            ]
          }
        ]
      }
    ]
  },
  "fifteen-beats": {
    "name": "Scaletta in quindici snodi",
    "summary": "La scaletta degli sceneggiatori: quindici svolte distribuite in tre atti.",
    "bestFor": "Trame compatte e commerciali, con svolte nette.",
    "metaTitle": "Scaletta narrativa in quindici snodi — Musael",
    "metaDescription": "La scaletta degli sceneggiatori: quindici svolte in tre atti. Per trame compatte e commerciali con punti di svolta netti.",
    "acts": [
      {
        "title": "Atto I",
        "synopsis": "Il mondo di prima e la scelta di lasciarlo.",
        "chapters": [
          {
            "title": "Immagine iniziale",
            "synopsis": "Il protagonista e il mondo prima della storia.",
            "scenes": [
              {
                "title": "Immagine iniziale",
                "synopsis": "Il protagonista e il mondo prima della storia."
              }
            ]
          },
          {
            "title": "Il tema viene enunciato",
            "synopsis": "Qualcuno dice di cosa parla davvero la storia; il protagonista ancora non lo capisce.",
            "scenes": [
              {
                "title": "Il tema viene enunciato",
                "synopsis": "Qualcuno dice di cosa parla davvero la storia; il protagonista ancora non lo capisce."
              }
            ]
          },
          {
            "title": "Impostazione",
            "synopsis": "La vita del protagonista, le persone che ne fanno parte e ciò che va sistemato.",
            "scenes": [
              {
                "title": "Impostazione",
                "synopsis": "La vita del protagonista, le persone che ne fanno parte e ciò che va sistemato."
              }
            ]
          },
          {
            "title": "Catalizzatore",
            "synopsis": "L'evento che mette in moto la storia.",
            "scenes": [
              {
                "title": "Catalizzatore",
                "synopsis": "L'evento che mette in moto la storia."
              }
            ]
          },
          {
            "title": "Esitazione",
            "synopsis": "Il protagonista non sa cosa fare.",
            "scenes": [
              {
                "title": "Esitazione",
                "synopsis": "Il protagonista non sa cosa fare."
              }
            ]
          },
          {
            "title": "Ingresso nel secondo atto",
            "synopsis": "Il protagonista sceglie una nuova strada.",
            "scenes": [
              {
                "title": "Ingresso nel secondo atto",
                "synopsis": "Il protagonista sceglie una nuova strada."
              }
            ]
          }
        ]
      },
      {
        "title": "Atto II",
        "synopsis": "La promessa della premessa, poi la caduta.",
        "chapters": [
          {
            "title": "Storia secondaria",
            "synopsis": "Una storia secondaria, spesso una relazione, che porta avanti il tema.",
            "scenes": [
              {
                "title": "Storia secondaria",
                "synopsis": "Una storia secondaria, spesso una relazione, che porta avanti il tema."
              }
            ]
          },
          {
            "title": "Divertimento e giochi",
            "synopsis": "La premessa prende vita: ciò per cui i lettori sono arrivati.",
            "scenes": [
              {
                "title": "Divertimento e giochi",
                "synopsis": "La premessa prende vita: ciò per cui i lettori sono arrivati."
              }
            ]
          },
          {
            "title": "Punto centrale",
            "synopsis": "Una falsa vittoria o sconfitta alza la posta in gioco.",
            "scenes": [
              {
                "title": "Punto centrale",
                "synopsis": "Una falsa vittoria o sconfitta alza la posta in gioco."
              }
            ]
          },
          {
            "title": "Gli avversari si avvicinano",
            "synopsis": "Dubbi dentro, pressione fuori.",
            "scenes": [
              {
                "title": "Gli avversari si avvicinano",
                "synopsis": "Dubbi dentro, pressione fuori."
              }
            ]
          },
          {
            "title": "Tutto è perduto",
            "synopsis": "L'opposto del punto centrale: il momento più basso.",
            "scenes": [
              {
                "title": "Tutto è perduto",
                "synopsis": "L'opposto del punto centrale: il momento più basso."
              }
            ]
          },
          {
            "title": "La notte oscura dell'anima",
            "synopsis": "Il protagonista piange ciò che ha perso e trova la lezione.",
            "scenes": [
              {
                "title": "La notte oscura dell'anima",
                "synopsis": "Il protagonista piange ciò che ha perso e trova la lezione."
              }
            ]
          }
        ]
      },
      {
        "title": "Atto III",
        "synopsis": "La lezione messa in pratica.",
        "chapters": [
          {
            "title": "Ingresso nel terzo atto",
            "synopsis": "Una nuova idea, nata dalla storia secondaria, apre una strada.",
            "scenes": [
              {
                "title": "Ingresso nel terzo atto",
                "synopsis": "Una nuova idea, nata dalla storia secondaria, apre una strada."
              }
            ]
          },
          {
            "title": "Finale",
            "synopsis": "Il protagonista ripara ciò che era rotto, cambiato per sempre.",
            "scenes": [
              {
                "title": "Finale",
                "synopsis": "Il protagonista ripara ciò che era rotto, cambiato per sempre."
              }
            ]
          },
          {
            "title": "Immagine finale",
            "synopsis": "Il mondo dopo, a specchio dell'immagine iniziale.",
            "scenes": [
              {
                "title": "Immagine finale",
                "synopsis": "Il mondo dopo, a specchio dell'immagine iniziale."
              }
            ]
          }
        ]
      }
    ]
  },
  "seven-point": {
    "name": "Struttura in sette punti",
    "summary": "Progetta a ritroso dal finale: aggancio, svolte, strette, punto centrale e risoluzione.",
    "bestFor": "Chi conosce prima il finale.",
    "metaTitle": "Modello narrativo in sette punti — Musael",
    "metaDescription": "Progetta a ritroso dal finale: aggancio, svolte, strette, punto centrale e risoluzione. Per chi conosce prima il finale.",
    "acts": [
      {
        "title": "",
        "synopsis": "",
        "chapters": [
          {
            "title": "Aggancio",
            "synopsis": "La situazione iniziale, opposta a quella della risoluzione.",
            "scenes": [
              {
                "title": "Aggancio",
                "synopsis": "La situazione iniziale, opposta a quella della risoluzione."
              }
            ]
          },
          {
            "title": "Svolta narrativa 1",
            "synopsis": "Il conflitto inizia e il protagonista viene spinto all'azione.",
            "scenes": [
              {
                "title": "Svolta narrativa 1",
                "synopsis": "Il conflitto inizia e il protagonista viene spinto all'azione."
              }
            ]
          },
          {
            "title": "Stretta 1",
            "synopsis": "L'antagonista fa pressione; il protagonista deve agire.",
            "scenes": [
              {
                "title": "Stretta 1",
                "synopsis": "L'antagonista fa pressione; il protagonista deve agire."
              }
            ]
          },
          {
            "title": "Punto centrale",
            "synopsis": "Il protagonista passa dal reagire all'agire.",
            "scenes": [
              {
                "title": "Punto centrale",
                "synopsis": "Il protagonista passa dal reagire all'agire."
              }
            ]
          },
          {
            "title": "Stretta 2",
            "synopsis": "Le cose vanno molto male; il piano fallisce.",
            "scenes": [
              {
                "title": "Stretta 2",
                "synopsis": "Le cose vanno molto male; il piano fallisce."
              }
            ]
          },
          {
            "title": "Svolta narrativa 2",
            "synopsis": "Il protagonista ottiene l'ultimo elemento necessario per vincere.",
            "scenes": [
              {
                "title": "Svolta narrativa 2",
                "synopsis": "Il protagonista ottiene l'ultimo elemento necessario per vincere."
              }
            ]
          },
          {
            "title": "Risoluzione",
            "synopsis": "La situazione finale, la risposta all'aggancio.",
            "scenes": [
              {
                "title": "Risoluzione",
                "synopsis": "La situazione finale, la risposta all'aggancio."
              }
            ]
          }
        ]
      }
    ]
  },
  "kishotenketsu": {
    "name": "Kishōtenketsu",
    "summary": "Quattro movimenti costruiti su una svolta anziché su un conflitto.",
    "bestFor": "Narrativa letteraria, racconti e libri quieti guidati dai personaggi.",
    "metaTitle": "Modello narrativo Kishōtenketsu — Musael",
    "metaDescription": "Quattro movimenti basati su una svolta anziché su un conflitto. Per narrativa letteraria, racconti e libri quieti guidati dai personaggi.",
    "acts": [
      {
        "title": "",
        "synopsis": "",
        "chapters": [
          {
            "title": "Ki: introduzione",
            "synopsis": "I personaggi e il loro mondo, con calma.",
            "scenes": [
              {
                "title": "Introduzione",
                "synopsis": "Chi, dove e com'è la quotidianità."
              }
            ]
          },
          {
            "title": "Shō: sviluppo",
            "synopsis": "La situazione si approfondisce, senza ancora una svolta.",
            "scenes": [
              {
                "title": "Sviluppo",
                "synopsis": "Conosciamo meglio i personaggi; piccole cose cambiano."
              }
            ]
          },
          {
            "title": "Ten: svolta",
            "synopsis": "Un elemento inatteso cambia il modo in cui vediamo tutto.",
            "scenes": [
              {
                "title": "La svolta",
                "synopsis": "Arriva qualcosa di nuovo, apparentemente scollegato."
              }
            ]
          },
          {
            "title": "Ketsu: ricomposizione",
            "synopsis": "Le parti si uniscono in una nuova comprensione.",
            "scenes": [
              {
                "title": "Ricomposizione",
                "synopsis": "La svolta incontra la storia; il significato cambia."
              }
            ]
          }
        ]
      }
    ]
  },
  "mystery": {
    "name": "Giallo",
    "summary": "Un crimine, un'indagine tra indizi e false piste e una rivelazione leale con il lettore.",
    "bestFor": "Gialli criminali, investigativi e cozy.",
    "metaTitle": "Modello narrativo per gialli — Musael",
    "metaDescription": "Un crimine, indizi, false piste e una rivelazione leale con il lettore. Per gialli criminali, investigativi e cozy.",
    "acts": [
      {
        "title": "Il crimine",
        "synopsis": "Qualcosa non va e qualcuno deve scoprire perché.",
        "chapters": [
          {
            "title": "La scoperta",
            "synopsis": "Il crimine o la scomparsa.",
            "scenes": [
              {
                "title": "Il corpo",
                "synopsis": "Il crimine viene scoperto; prime impressioni e prime domande."
              },
              {
                "title": "L'investigatore",
                "synopsis": "Chi indaga e perché la vicenda lo riguarda."
              }
            ]
          }
        ]
      },
      {
        "title": "L'indagine",
        "synopsis": "Indizi, sospettati e false piste.",
        "chapters": [
          {
            "title": "Sospettati",
            "synopsis": "Tutti quelli con un movente e un alibi.",
            "scenes": [
              {
                "title": "Interrogatori",
                "synopsis": "Ogni sospettato ha un motivo per mentire."
              },
              {
                "title": "Il primo indizio",
                "synopsis": "Un fatto che conterà più avanti; sii leale con il lettore."
              }
            ]
          },
          {
            "title": "False piste",
            "synopsis": "L'indagine prende la direzione sbagliata.",
            "scenes": [
              {
                "title": "Un depistaggio",
                "synopsis": "Le prove indicano la persona sbagliata."
              },
              {
                "title": "Escalation",
                "synopsis": "Un secondo crimine o una minaccia alza la posta in gioco."
              }
            ]
          },
          {
            "title": "La verità nascosta",
            "synopsis": "L'investigatore vede ciò che era sempre stato lì.",
            "scenes": [
              {
                "title": "Il tassello mancante",
                "synopsis": "Un piccolo dettaglio fa combaciare gli indizi precedenti."
              }
            ]
          }
        ]
      },
      {
        "title": "La rivelazione",
        "synopsis": "La soluzione e il suo prezzo.",
        "chapters": [
          {
            "title": "La soluzione",
            "synopsis": "Ogni indizio viene spiegato.",
            "scenes": [
              {
                "title": "La rivelazione",
                "synopsis": "Il colpevole viene indicato e il ragionamento esposto."
              },
              {
                "title": "Le conseguenze",
                "synopsis": "La giustizia, o la sua assenza, e ciò che resta all'investigatore."
              }
            ]
          }
        ]
      }
    ]
  },
  "romance": {
    "name": "Romance",
    "summary": "Due persone, ciò che le tiene lontane e cosa serve per scegliersi.",
    "bestFor": "Romance e storie d'amore in qualsiasi ambientazione.",
    "metaTitle": "Modello narrativo romance — Musael",
    "metaDescription": "Due persone, ciò che le tiene lontane e cosa serve per scegliersi. Per romance e storie d'amore in qualsiasi ambientazione.",
    "acts": [
      {
        "title": "Innamorarsi",
        "synopsis": "Si incontrano, resistono e iniziano a innamorarsi.",
        "chapters": [
          {
            "title": "L'incontro",
            "synopsis": "Il primo incontro, con la scintilla e l'ostacolo.",
            "scenes": [
              {
                "title": "Incontro",
                "synopsis": "I due protagonisti si incontrano; qualcosa dell'altro li colpisce nel profondo."
              },
              {
                "title": "Resistenza",
                "synopsis": "Perché non può funzionare: obiettivi, ferite o circostanze."
              }
            ]
          },
          {
            "title": "Avvicinarsi",
            "synopsis": "Costretti a stare insieme, si vedono per ciò che sono.",
            "scenes": [
              {
                "title": "Insieme per caso",
                "synopsis": "Una situazione li tiene vicini."
              },
              {
                "title": "Il primo momento autentico",
                "synopsis": "Uno scorcio di chi è davvero l'altro."
              }
            ]
          }
        ]
      },
      {
        "title": "Dubitare",
        "synopsis": "Un impegno, poi la paura che lo spezza.",
        "chapters": [
          {
            "title": "Il punto centrale",
            "synopsis": "Cedono a ciò che provano.",
            "scenes": [
              {
                "title": "Impegno",
                "synopsis": "Un bacio, una confessione o una promessa."
              }
            ]
          },
          {
            "title": "La rottura",
            "synopsis": "La vecchia ferita o l'ostacolo esterno ha la meglio, per ora.",
            "scenes": [
              {
                "title": "Dubbio",
                "synopsis": "Le vecchie paure tornano."
              },
              {
                "title": "La separazione",
                "synopsis": "Si lasciano, ciascuno convinto di avere ragione."
              }
            ]
          }
        ]
      },
      {
        "title": "Scegliere",
        "synopsis": "Crescita, un grande gesto e un futuro condiviso.",
        "chapters": [
          {
            "title": "Insieme",
            "synopsis": "Ognuno cambia abbastanza da meritare l'altro.",
            "scenes": [
              {
                "title": "Il grande gesto",
                "synopsis": "Uno dei due rischia tutto per dimostrare di essere cambiato."
              },
              {
                "title": "Felici e contenti",
                "synopsis": "Oppure felici per ora: il futuro che scelgono."
              }
            ]
          }
        ]
      }
    ]
  }
}
